import * as React from 'react';
import FileService from '../../../services/fileService';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { FileModel } from "../../../models/fileModel";
import { MedicineLeafletTypes } from '../../../common/enums';
import Translate from '../../../common/functions/translate';
import pdf256 from "../../../assets/images/pdf256.png";
import { formatBytes } from '../../../common/functions/helperFunctions';
import * as Helperfunction from '../../../common/functions/helperFunctions';
import * as Constants from '../../../common/constants';
import { connect } from 'react-redux';
import { FileSystemType } from '../../../common/enums';

interface IProps {
  medicineId: any,
  lang: string,
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  leaflets: Array<FileModel>,
  file: any
}

class leafletTab extends React.Component<IProps, IState> {
  fileService = new FileService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      leaflets: new Array<FileModel>(0),
      file: null
    };
  }

  componentDidMount() {
    this.getMedicineLeaflets();
  }

  getMedicineLeaflets = () => {
    this.setState({
      isLoading: true
    });

    this.fileService.getMedicineLeaflets(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          leaflets: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  getLeafletTypeName(id: number) {
    let enumElement = Object
      .keys(MedicineLeafletTypes)
      .find(key => MedicineLeafletTypes[key] === id);

    return Translate(enumElement);
  }

  public render() {

    var leafletElement: any = null;
    const { medicineId, isLoading, error, leaflets } = this.state;

    if (leaflets.length > 0) {
      leafletElement =
        <div className="leaflets">
          {leaflets.map(m =>
            <div key={m.fileId} style={{ marginBottom: '10px', marginRight: "20px" }}>
              <div style={{ float: "left", paddingRight: '10px' }}>
                <a href={`${Constants.apiUrl}/file/openFile/${m.fileId}/${FileSystemType.Leaflets}/${m.fileName}`} target="_blank" title={m.fileName}>
                  <img src={Helperfunction.getIconByFileType(m.fileType)} style={{ height: "42px" }}></img>
                </a>
              </div>
              <div style={{ float: "left" }}>
                <div>
                  <a href={`${Constants.apiUrl}/file/openFile/${m.fileId}/${FileSystemType.Leaflets}/${m.fileName}`} target="_blank" title={m.fileName}>
                    {this.getLeafletTypeName(m.medicineLeafletTypeId)}
                  </a>
                </div>
                <div style={{ color: '#999', fontSize: '.9em' }}>
                  {formatBytes(m.fileSizeInBytes, 0)} | {m.fileType.toUpperCase()}
                </div>
              </div>
            </div>
          )}
        </div>
    }

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
        {leafletElement}
      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(leafletTab);